import { useFrame } from '@react-three/fiber';
import { useMemo, useRef } from 'react';
import * as THREE from 'three';

interface PlanetProps { progress: number }

export function Planet({ progress }: PlanetProps) {
  const group = useRef<THREE.Group>(null);
  const material = useRef<THREE.MeshStandardMaterial>(null);
  const atmosphere = useRef<THREE.MeshBasicMaterial>(null);
  const rocky = useMemo(() => new THREE.Color('#3a261d'), []);
  const living = useMemo(() => new THREE.Color('#1d4a56'), []);

  useFrame((_, delta) => {
    if (!group.current || !material.current || !atmosphere.current) return;
    group.current.rotation.y += delta * 0.07;
    group.current.rotation.x = Math.sin(progress * Math.PI) * 0.08;
    const evolution = THREE.MathUtils.smoothstep(progress, 0.08, 0.32);
    material.current.color.copy(rocky).lerp(living, evolution);
    material.current.roughness = THREE.MathUtils.lerp(0.96, 0.58, evolution);
    atmosphere.current.opacity = evolution * 0.18;
    group.current.position.z = THREE.MathUtils.lerp(0, 6, THREE.MathUtils.smoothstep(progress, 0.22, 0.42));
    group.current.scale.setScalar(THREE.MathUtils.lerp(1, 2.4, THREE.MathUtils.smoothstep(progress, 0.22, 0.42)));
  });

  return (
    <group ref={group} position={[0.6, 0, 0]}>
      <mesh castShadow receiveShadow>
        <icosahedronGeometry args={[2.2, 8]} />
        <meshStandardMaterial ref={material} color="#3a261d" roughness={0.96} metalness={0.08} />
      </mesh>
      <mesh scale={1.045}>
        <sphereGeometry args={[2.2, 64, 64]} />
        <meshBasicMaterial ref={atmosphere} color="#70cfff" transparent opacity={0} side={THREE.BackSide} />
      </mesh>
    </group>
  );
}
